export default __webpack_public_path__ + "../img/1e0338616892ae38cb60cae6aa67128e.png";